import { Fragment, useEffect, useMemo, useState } from 'react';
import { noData } from '../../../components/ExportImgFigma';
import '../styles.scss';

// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { ConfigProvider, DatePicker, Input, Pagination, Tabs } from 'antd';

import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import { TabsProps } from 'antd/lib';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { ListField } from '../../../api/Customer_V2/customerApi_V2';
import { ICustomerFields } from '../../../api/salesSericeCustomer/salesSericeCustomerApi';
import useDebounce from '../../../hook/useDebounce';
import useToast from '../../../hook/useToast';
import { getWidthFromHeader, renderValueAsJSX } from '../../../until';
import { ColumnKey } from '../../Customers/Tabs/CarListCardClone';
import { FlattenedField } from '../../CustomersV2/indexV2';
import StatusCellRenderer from '../../VehicleManagement/VehicleTypeManagement/Component/StatusCellRenderer';
import TabsFeilds from '../Modal/TabsFeilds';
import VehicleInvoiceDetail from './VehicleInvoiceDetail';
import TabTableDetail from './TabTableDetail';
dayjs.locale('vi');

const { RangePicker } = DatePicker;


const dataListFieldsByCustomerRecordActive = [
    {
        "id": 1,
        "title": "Hoá đơn xe",
        "fields": [
            {
                "id": 1,
                "fieldCode": "representative",
                "fieldLabel": "Người đại diện",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 2,
                "fieldCode": "carName",
                "fieldLabel": "Tên xe",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 3,
                "fieldCode": "vin",
                "fieldLabel": "Số khung (VIN)",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 4,
                "fieldCode": "licensePlate",
                "fieldLabel": "Biển số xe",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 5,
                "fieldCode": "color",
                "fieldLabel": "Màu xe",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 6,
                "fieldCode": "total",
                "fieldLabel": "Tổng tiền",
                "inputType": "number",
                "isActive": 1
            },
            {
                "id": 7,
                "fieldCode": "invoiceNumber",
                "fieldLabel": "Số hóa đơn",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 8,
                "fieldCode": "invoiceDate",
                "fieldLabel": "Ngày xuất hóa đơn",
                "inputType": "date",
                "isActive": 1
            },
            {
                "id": 9,
                "fieldCode": "buyerUnit",
                "fieldLabel": "Đơn vị mua xe",
                "inputType": "string",
                "isActive": 1
            },
            {
                "id": 10,
                "fieldCode": "dealer",
                "fieldLabel": "Điểm bán hàng",
                "inputType": "string",
                "isActive": 1
            }
        ]


    }
]

const dataListFieldsByCustomerRecordNotActive = [
    {
        "id": 1,
        "title": "Hoá đơn xe",
        "fields": [
        ]
    }
]

const columnDefsDetail = [
    { headerName: "Số khung (VIN)", field: "vin", resizable: true, sortable: true, filter: true },
    { headerName: "Biển số xe", field: "plateNumber", resizable: true, sortable: true, filter: true },
    { headerName: "Màu xe", field: "color", resizable: true, sortable: true, filter: true },
    { headerName: "Ngày mua xe", field: "purchaseDate", resizable: true, sortable: true, filter: true },
    { headerName: "Đã nhắc BD 1.000 Km", field: "reminder1000Km", resizable: true, sortable: true, filter: true },
    { headerName: "Đã vào BD 1000 Km", field: "maintained1000Km", resizable: true, sortable: true, filter: true },
    { headerName: "Ngày nhắc BD", field: "reminderDate", resizable: true, sortable: true, filter: true },
    { headerName: "Ngày liên hệ lần 1", field: "contactDate1", resizable: true, sortable: true, filter: true },
    { headerName: "Nội dung liên hệ lần 1", field: "contactContent1", resizable: true, sortable: true, filter: true },
    { headerName: "Ngày liên hệ lần 2", field: "contactDate2", resizable: true, sortable: true, filter: true },
    { headerName: "Nội dung liên hệ lần 2", field: "contactContent2", resizable: true, sortable: true, filter: true },
    { headerName: "Ngày liên hệ lần 3", field: "contactDate3", resizable: true, sortable: true, filter: true },
    { headerName: "Nội dung liên hệ lần 3", field: "contactContent3", resizable: true, sortable: true, filter: true },
    { headerName: "Không liên hệ được", field: "notContacted", resizable: true, sortable: true, filter: true },
    { headerName: "Nội dung", field: "content", resizable: true, sortable: true, filter: true },
    { headerName: "Ghi chú", field: "note", resizable: true, sortable: true, filter: true },
];

const rowDataDetail = [
    {
        vin: "RNHA43TNART009B50",
        plateNumber: "65C22983",
        color: "Trắng",
        purchaseDate: "22/02/2020",
        reminder1000Km: "Có",
        maintained1000Km: "Không",
        reminderDate: "22/02/2022",
        contactDate1: "22/02/2022",
        contactContent1: "LIÊN HỆ LẠI SAU",
        contactDate2: "22/02/2022",
        contactContent2: "LIÊN HỆ LẠI SAU",
        contactDate3: "22/02/2022",
        contactContent3: "KHÔNG NGHE MÁY",
        notContacted: "Không có số điện thoại",
        content: "Liên hệ lại nhưng anh cũng chưa có dự định",
        note: "CHƯA GỌI XE DA",
    },
];


const rowData = [
    {
        date: "22/02/2022",
        orgUnit: "THACO AUTO Cần Thơ (T36)",
        salesPoint: "CN Vĩnh Long (DL) - 6501021",
        interactionType: "Đặt lịch hẹn SC",
        contactType: "KH liên hệ",
        carName: "New Mazda CX-8 2.5 Luxury",
        contactPerson: "Tấn Tài",
        staff: "Phạm Anh Quốc (NV123)",
        endDate: "22/02/2022"
    },
    {
        date: "22/02/2022",
        orgUnit: "THACO AUTO Cần Thơ (T36)",
        salesPoint: "CN Vĩnh Long (DL) - 6501021",
        interactionType: "Chăm sóc dịch vụ",
        contactType: "THACO AUTO liên hệ",
        carName: "FUSO - FJ170",
        contactPerson: "Tấn Tài",
        staff: "Phạm Anh Quốc (NV123)",
        endDate: "Không xác định"
    },
    {
        date: "22/02/2022",
        orgUnit: "THACO AUTO Cần Thơ (T36)",
        salesPoint: "CN Vĩnh Long (DL) - 6501021",
        interactionType: "Chăm sóc bán hàng",
        contactType: "THACO AUTO liên hệ",
        carName: "New Mazda CX-8 2.5 Luxury",
        contactPerson: "Tấn Tài",
        staff: "Phạm Anh Quốc (NV123)",
        endDate: "22/02/2022"
    }
];

const columnDefs = [
    {
        headerName: "Hành động", field: "action", cellRenderer: (params: any) => {
            // const { view, edit, delete: isDelete } = params?.data?.permissionMenu
            return (
                <div className='d-flex gap-4 justify-start align-center  h-full'>

                    <EyeOutlined
                        className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
                    // onClick={() => gInfoVehicleModel(id)}
                    />

                </div>

            )
        }
    },
    { headerName: "Ngày", field: "date", sortable: true, filter: true },
    { headerName: "Đơn vị", field: "orgUnit", sortable: true, filter: true },
    { headerName: "Điểm bán hàng", field: "salesPoint", sortable: true, filter: true },
    { headerName: "Loại tương tác", field: "interactionType", sortable: true, filter: true },
    { headerName: "Phân loại liên hệ", field: "contactType", sortable: true, filter: true },
    { headerName: "Tên xe", field: "carName", sortable: true, filter: true },
    {
        headerName: "Người liên hệ", field: "contactPerson",
        cellRenderer: (params: any) => {
            return (

                params.value ? <span className="custom-page-css font-regular text-lg text-096DD9">
                    {params.value}
                </span> :

                    <span >
                        Không xác định
                    </span>


            );
        }
    },
    { headerName: "Nhân viên", field: "staff", sortable: true, filter: true },
    { headerName: "Ngày kết thúc", field: "endDate", sortable: true, filter: true }
];



const generateColumnsFromCodesAgGridReact = (
    codes: ColumnKey[],
    fields: ICustomerFields[],
    actionColumn?: ColDef<any, any>,
    onToggleStatus?: (id: number, next: boolean, rowData: any) => void, // thêm callback
): ColDef[] => {
    const baseColumns = codes
        ?.map(code => {
            const field = fields.find(f => f.fieldCode === code)
            if (!field) return null
            if (field.fieldCode === "status") {
                return {
                    headerName: field.fieldLabel,
                    field: field.fieldCode,
                    colId: field.fieldCode,
                    sortable: true,
                    cellRenderer: StatusCellRenderer,
                    cellRendererParams: {
                        onToggle: (id: number, next: boolean, rowData: any) => {
                            if (onToggleStatus) {
                                onToggleStatus(id, next, rowData)
                            }
                        },
                        idKey: 'key'
                    }
                }
            }

            return {
                headerName: field.fieldLabel,
                field: field.fieldCode,
                colId: field.fieldCode,
                sortable: true,
                width: getWidthFromHeader(field.fieldLabel),
                cellRenderer: (params: any) => renderValueAsJSX(params.value,field.fieldCode)
            } as ColDef
        })
        .filter(Boolean) as ColDef[]

    return actionColumn ? [actionColumn, ...baseColumns] : baseColumns
}



export default function SalesAndService({ stData = {} as any, stChange = (data: any) => { } }) {

    const pushToast = useToast();

    const [isSettingShow, setSettingShow] = useState(false)

    const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([])
    const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([])

    const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])

    const [demoList, setDemoList] = useState<any[]>([])
    const [rowHeight, setRowHeight] = useState(40)

    useEffect(() => {
        gListFieldsActive()
        gList()


        const handleResize = () => {
            const baseFactor = (48 * 100) / 1440 / 100
            const factor = window.innerWidth > 1440 ? baseFactor * 0.9 : baseFactor
            const newHeight = Math.round(window.innerWidth * factor)
            setRowHeight(newHeight)
        }
        handleResize()

        window.addEventListener('resize', handleResize)

        return (() => {
            // setPagination({ current: 1, pageSize: 20, total: 0 })
            // setSelectedRowKeys([])
            window.removeEventListener('resize', handleResize)
        })
    }, [])


    const onChange = (key: string) => {
        // setIsTab(Number(key));
    };

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span className='custom-page-css font-light text-lg'>Chi tiết</span>,
            children: <TabTableDetail dataRow={rowDataDetail} columnDefs={columnDefsDetail} />,
        },
    ];


    const gList = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

        setDemoList(rowData)
    }, 1000)


    const actionColumn: ColDef = {
        headerName: 'Hành động',
        field: 'action',
        colId: 'action',
        // width: getWidthFromHeader('Hành động'),
        cellRenderer: (params: any) => {
            // const { view, edit, delete: isDelete } = params?.data?.permissionMenu
            return (
                <div className='d-flex gap-4 justify-start align-center  h-full'>

                    <EyeOutlined
                        className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
                    // onClick={() => gInfoVehicleModel(id)}
                    />
                    <EditOutlined
                        className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
                    // onClick={() => gInfoVehicleModel(id, false)}
                    />
                    <DeleteOutlined
                        className={`text-F5222D text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
                    // onClick={() => openModalDelete(Number(id))}
                    />

                </div>

            )
        },
    }


    const gListFieldsActive = async () => {
        const flattenedFields = await dataListFieldsByCustomerRecordActive.flatMap(choice =>
            choice.fields.map(field => ({
                ...field,
                parentId: choice.id,
            }))
        );
        setDataFilterActive(flattenedFields)


        gListFieldsNotActive()
    }
    const gListFieldsNotActive = async () => {
        setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive)


    }
    const onSaveDataFields = (iSsuccess?: boolean, message?: string, dataFilterActive?: FlattenedField[], dataFilterNoActive?: ListField[]) => {
        if (iSsuccess) {
            setSettingShow(false)
            pushToast(message, "success")
            setDataFilterActive(dataFilterActive ?? [])
            setDataFilterNoActive(dataFilterNoActive ?? [])
            gList()

        } else {
            pushToast(message, "warning")
        }
    }

    const onCloseDataFields = () => {
        setSettingShow(false)
    }

    const memoizedColumnDefs = useMemo(() => {
        return generateColumnsFromCodesAgGridReact(
            ColumnsMapShow, dataFilterActive, actionColumn,
            (id: number, next: boolean, rowData: any) => console.log(id, next, rowData)

        );
    }, [ColumnsMapShow]);

    useEffect(() => {
        const codes = dataFilterActive.map(f => f.fieldCode)
        setColumnsMapShow(codes)
    }, [dataFilterActive])

    return (
        <Fragment>
            <div className="custom-page-css w-full flex flex-col items-center justify-between gap-3 pt-3">
                <div className={` w-full`}>
                    <div className="ag-theme-alpine custom-table-ag" style={{ width: '100%' }}>
                        <AgGridReact<any>
                            rowSelection={undefined}
                            rowData={stData.vehicle_owner_total_interact || []}
                            columnDefs={[
                                { headerName: 'Đơn vị', field: 'own_branch_name' },
                                { headerName: 'Số khung', field: 'own_chassis_no' },
                                { headerName: 'Màu xe', field: 'own_color_name' },
                                { headerName: 'Số máy', field: 'own_engine_no' },
                                { headerName: 'Loại động cơ', field: 'own_engine_type' },
                                { headerName: 'Năm sản xuất', field: 'own_made_year' },
                                { headerName: 'Biển số', field: 'own_number_plate' },
                                { headerName: 'Ngày mua', field: 'own_purchase_date' },
                                { headerName: 'Chi nhánh', field: 'own_route_name' },
                                { headerName: 'Hãng xe', field: 'own_vehicle_brand' },
                                { headerName: 'Mẫu xe', field: 'own_vehicle_model' },
                                { headerName: 'Tên xe', field: 'own_vehicle_name' },
                                { headerName: 'Ngày KH hẹn vào xưởng', field: 'repair_book_date' },
                                { headerName: 'Đơn vị', field: 'repair_branch_name' },
                                { headerName: 'Tổ', field: 'repair_dept_code_list' },
                                { headerName: 'Nội dung sửa chữa', field: 'repair_description' },
                                { headerName: 'Ngày nhắc bảo dưỡng tiếp theo', field: 'repair_doc_date_remind' },
                                { headerName: 'Ngày sửa chữa', field: 'repair_effective_get_date' },
                                { headerName: 'Cố vấn dịch vụ', field: 'repair_employee_name' },
                                { headerName: 'Ngày hoàn thành', field: 'repair_end_repair_date' },
                                { headerName: 'Ngày dự kiến hoàn thành', field: 'repair_estimated_finished_date' },
                                { headerName: 'Doanh thu vật tư phụ tùng', field: 'repair_item_amount' },
                                { headerName: 'Loại bảo dưỡng', field: 'repair_maintenance_type' },
                                { headerName: 'Mục cần làm sớm', field: 'repair_note' },
                                { headerName: 'Số km', field: 'repair_present_mile_age' },
                                { headerName: 'Ngày giao xe (sau khi sửa chữa xong)', field: 'repair_receive_date' },
                                { headerName: 'Chi nhánh', field: 'repair_route_name' },
                                { headerName: 'Kĩ thuật viên', field: 'repair_technician_name' },
                                { headerName: 'Tổng tiền', field: 'repair_total_amount' },
                            ]}
                            //    columnDefs={memoizedColumnDefs}
                            domLayout="autoHeight"
                            className="my-auto-height-grid"
                            rowHeight={55}
                            getRowStyle={(params: any) => ({
                                backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
                            })}
                            overlayNoRowsTemplate={`
                           <div style="text-align: center; padding: 20px;">
                           <br />
                               <img src="${noData}" alt="No data" style="max-width: 150px;" />
                           <br />
                               <div>Không có dữ liệu</div>
                           <br />
                           </div>
                           `}
                        />

                    </div>
                </div>
                {/* <div className="custom-page-css w-full flex items-center justify-between gap-3 pt-3">
                    <Tabs defaultActiveKey="1" items={items} onChange={onChange} className='w-full' />
                </div> */}
            </div>
        </Fragment>
    )

}
